// extracted by mini-css-extract-plugin
export var quantityInput = "_ms-0";